import React, { useState, useEffect, useCallback } from 'react';
import LandingPage from './LandingPage';
import MainApp from './MainApp';
import './App.css';

// Deterministic so the particle field doesn't reshuffle on every render.
const PARTICLES = Array.from({ length: 14 }, (_, i) => ({
  left: (i * 7.3 + 4) % 100,
  dur: 11 + ((i * 3) % 9),
  delay: (i * 1.6) % 12,
}));

function App() {
  const [started, setStarted] = useState(false);

  // Pointer spotlight that follows the cursor across the whole app.
  useEffect(() => {
    const onMove = (e) => {
      document.documentElement.style.setProperty('--mx', `${e.clientX}px`);
      document.documentElement.style.setProperty('--my', `${e.clientY}px`);
    };
    window.addEventListener('pointermove', onMove, { passive: true });
    return () => window.removeEventListener('pointermove', onMove);
  }, []);

  // Dismiss the pre-hydration splash once React has painted.
  useEffect(() => {
    const boot = document.getElementById('boot');
    if (!boot) return;
    boot.classList.add('gone');
    const t = setTimeout(() => boot.remove(), 600);
    return () => clearTimeout(t);
  }, []);

  // Top scroll-progress bar.
  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? window.scrollY / max : 0;
      document.documentElement.style.setProperty('--p', String(p));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  const go = useCallback((next) => {
    setStarted(next);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, []);

  return (
    <div className="app-shell">
      <div className="aurora" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
      <div className="grid-overlay" aria-hidden="true" />
      <div className="particles" aria-hidden="true">
        {PARTICLES.map((p, i) => (
          <i
            key={i}
            style={{
              left: `${p.left}%`,
              animationDuration: `${p.dur}s`,
              animationDelay: `${p.delay}s`,
            }}
          />
        ))}
      </div>
      <div className="spotlight" aria-hidden="true" />
      <div className="scroll-progress" aria-hidden="true" />

      <div className="view" key={started ? 'app' : 'landing'}>
        {started ? (
          <MainApp onBack={() => go(false)} />
        ) : (
          <LandingPage onStart={() => go(true)} />
        )}
      </div>
    </div>
  );
}

export default App;
